import { render } from "./CopyCompanySettingsModal.vue?vue&type=template&id=2118622c&scoped=true"
import script from "./CopyCompanySettingsModal.vue?vue&type=script&lang=js"
export * from "./CopyCompanySettingsModal.vue?vue&type=script&lang=js"

import "./CopyCompanySettingsModal.vue?vue&type=style&index=0&id=2118622c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2118622c"]])

export default __exports__